import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';

var _excluded = ["id", "inputProps", "isChecked", "isDisabled", "label", "labelDescription", "onChange", "name", "value", "valueDescription", "classList", "children", "ariaDescribedBy", "customRadioClassList"];
var propTypes = {
  /** Unique identifier for the radio input. Used for `input` and `label` association */
  id: PropTypes.string.isRequired,
  /** Main label for the radio button, displayed next to the custom radio */
  label: PropTypes.node.isRequired,
  /** Name for the radio group. All radio buttons with the same name are grouped together */
  name: PropTypes.string.isRequired,
  /** Callback fired when the radio button is selected */
  onChange: PropTypes.func.isRequired,
  /** Value of the radio button */
  value: PropTypes.string.isRequired,
  /** ID of the element that describes the radio button for accessibility */
  ariaDescribedBy: PropTypes.string,
  /** Optional additional content to render below the radio button */
  children: PropTypes.node,
  /** Additional CSS classes for the outer wrapper */
  classList: PropTypes.string,
  /** Additional CSS classes for the custom radio indicator */
  customRadioClassList: PropTypes.string,
  /** Arbitrary attributes to be applied to the `input` element (e.g., `data-*`, `aria-*`) */
  inputProps: PropTypes.object,
  /** If true, the radio button is selected */
  isChecked: PropTypes.bool,
  /** If true, the radio button is disabled and not interactive */
  isDisabled: PropTypes.bool,
  /** Additional description for the label, rendered as secondary text */
  labelDescription: PropTypes.node,
  /** Additional description for the value, rendered next to the label */
  valueDescription: PropTypes.node
};
function RadioButton(_ref) {
  var id = _ref.id,
    inputProps = _ref.inputProps,
    isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    label = _ref.label,
    labelDescription = _ref.labelDescription,
    onChange = _ref.onChange,
    name = _ref.name,
    value = _ref.value,
    valueDescription = _ref.valueDescription,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    children = _ref.children,
    ariaDescribedBy = _ref.ariaDescribedBy,
    _ref$customRadioClass = _ref.customRadioClassList,
    customRadioClassList = _ref$customRadioClass === void 0 ? '' : _ref$customRadioClass,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: "radio-button ".concat(classList),
    "data-testid": "radio-button-".concat(id)
  }, props), /*#__PURE__*/React__default.createElement("input", _extends({
    "aria-describedby": ariaDescribedBy,
    checked: isChecked,
    disabled: isDisabled,
    id: id,
    name: name,
    type: "radio",
    onChange: onChange,
    value: value
  }, inputProps)), /*#__PURE__*/React__default.createElement("label", {
    "data-testid": "radio-button-label",
    htmlFor: id
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "custom-radio ".concat(customRadioClassList),
    "data-testid": "radio-button-custom-radio"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "radio-button-interior-label"
  }, label, labelDescription && /*#__PURE__*/React__default.createElement("span", {
    className: "secondary",
    "data-testid": "label-description"
  }, labelDescription)), valueDescription && /*#__PURE__*/React__default.createElement("span", {
    "data-testid": "value-description"
  }, valueDescription)), children);
}
RadioButton.propTypes = propTypes;

export { RadioButton as default };
//# sourceMappingURL=RadioButton.js.map
